module.exports = __webpack_public_path__ + "assets/microsoft-iis.589674db.svg";